// src/hooks/useTutorial.js
import { useState, useCallback, useEffect } from "react";

const key = (uid) => `pp_tut_${uid}`;

export function useTutorial(uid) {
  const [enabled, setEnabled] = useState(() => {
    if (!uid) return false;
    const raw = localStorage.getItem(key(uid));
    return raw === null ? true : raw === "true";
  });

  // Re-sync when uid changes (e.g. after registration — new users have no key so tutorial auto-shows)
  useEffect(() => {
    if (!uid) { setEnabled(false); return; }
    const raw = localStorage.getItem(key(uid));
    setEnabled(raw === null ? true : raw === "true");
  }, [uid]);

  const setTutorialEnabled = useCallback((val) => {
    setEnabled(val);
    if (uid) localStorage.setItem(key(uid), String(val));
  }, [uid]);

  return { tutorialEnabled: enabled, setTutorialEnabled };
}
